import { Link } from "react-router-dom";
import styled from "styled-components/macro";
import { PLUGIN_CREATION_UNAVAILABLE_MESSAGE } from "../../../../src/shared/constants";

const AccessBanner = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  border: 1px solid var(--grey-3);
  border-radius: 14px;
  background: var(--menu-color);
  color: var(--grey-0);
  font-family: "Inter";
  font-size: 16px;
  line-height: 1.5;
  text-align: left;

  a {
    color: var(--primary-cta);
  }
`;

export default function PluginCreationAccessGate({ blocked, children }) {
  if (!blocked) return children ?? null;

  return (
    <AccessBanner aria-label="Plugin creation subscription required">
      {PLUGIN_CREATION_UNAVAILABLE_MESSAGE}{" "}
      <Link to="/app/plans?ref=plugin-create">Subscribe to Sudowrite</Link>.
    </AccessBanner>
  );
}
